import Vue from 'vue';
import ApiUrl from '../apiurl';
import Permissions from "../permissions.js"
export default {
    namespaced: true,
    state: {
        userConfig: null,
        token:null,
        currentLoginInfo:null,

    },
    getters: {
        userConfig: (state) => {
            return state.userConfig;
        },
        token:(state) =>{
            return state.token;
        },
        currentLoginInfo:(state) =>{
            return state.currentLoginInfo;
        },
        checkPermission:(state)=>{

            return (key)=>{
                  if(!state.userConfig || state.userConfig.auth.grantedPermissions[key]==undefined)
                   {
                       return false;
                   }
                  return  state.userConfig.auth.grantedPermissions[key];
    
            };
           
        },
      

    },

    mutations: {
        setUserConfig(state, newValue) {
            Vue.set(state, 'userConfig', newValue);
        },
        setToken(state,newValue)
        {
            Vue.set(state,'token',newValue);
        },
        setCurrentLoginInfo(state,newValue)
        {
            Vue.set(state,'currentLoginInfo',newValue);
        }
    },
    
    actions: {
          ///api/services/app/Session/GetCurrentLoginInformations
          async  check({state},key){

           
              if(!state.userConfig || state.userConfig.auth.grantedPermissions[key]==undefined)
               {
                   return false;
               }
              return  state.userConfig.auth.grantedPermissions[key];

        },
        async login({commit},{params,handle}){
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.user.login,params);
                if(rsp ) {             
                    if(rsp.data && rsp.data.success)
                    {
                        commit('setToken', rsp.data.result); 
                    }
                    handle&&handle(rsp);
                }
            } catch(e) {
                handle&&handle(e);
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
     async getUserConfig({commit,state},{handle})
        {
            commit('startLoading', null, { root: true });
            try {
               
                const rsp = await axios.get(ApiUrl.common.info);
                if(rsp && rsp.data && rsp.data.success)
                    {
                        commit('setUserConfig', rsp.data.result); 
                      
                    }
                handle && handle(rsp);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        },
        async getCurrentLoginInfo({commit},{handle})
        {
            commit('startLoading', null, { root: true });
            try {

                const rsp = await axios.get(ApiUrl.user.logininfo);
                if(rsp && rsp.data && rsp.data.success)
                    {
                        commit('setCurrentLoginInfo', rsp.data.result); 
                    }
                handle && handle(rsp);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, {root: true});
            }
        }
       
    }

}
